import axios, { AxiosResponse } from "axios";
import { createStore } from "vuex";
import authModule from "./modules/authModule";

import { TypeBuyLoyalityData } from "@/types";
import { TypeCertificateObj, TypeAbonementObj, IResponseDesings } from "@/types/typesOfApi";

import { IState } from "@/types/typesOfState";

import sortedLoyalityByTitle from "@/functions/sortedLoyalityByTitle";

export default createStore<IState>({
  state: {
    allLoyalityTypes: {
      abonements: [],
      certificates: [],
    },
    allDesignTypes: null,
    currentLoyalityKind: null,

    salonId: null,
    orderId: null,

    currentShopStep: 0,
    lastBlockStep: 0,
    numberOfSteps: {
      'self': 7,
      'other': 8,
    },

    loyalityShopData: {
      receiver: null,
      buyLoyalityType: null,
      designType: null,
      emailRecipient: "self",
      buyerData: {
        phone: '',
        email: '',
        name: null,
      },
      clientData: {
        phone: '',
        email: '',
        name: null,
      },
      byCertificate: {
        name: null,
        seanceLength: null,
        nominal: null,
      },
      byAbonement: {
        name: null,
        seanceLength: null,
        seats: null,
      },
    },

    sortedLoyalityByName: {
      abonements: {},
      certificates: {},
    },

    isPaymentLoader: false,
    isPaymentSuccess: false,

    currentPaymentData: {},

    currentPagePayment: {},
  },
  getters: {},
  mutations: {},
  actions: {
    async getAbonementTypes(context) {
      return await axios({
        method: "GET",
        url: `https://qoob.store/api/v1/booking/yclients/company/${context.state.salonId}/abonement/types/`,
      }).then((data) => {
        context.state.allLoyalityTypes.abonements =
          data.data.result.abonement_types;
        sortedLoyalityByTitle(
          data.data.result.abonement_types.filter((i: any) => !i.is_archived && i.is_online_sale_enabled),
          context.state.sortedLoyalityByName.abonements,
          "abonement"
        );
      });
    },
    async getCertificateTypes(context) {
      return await axios({
        method: "GET",
        url: `https://qoob.store/api/v1/booking/yclients/company/${context.state.salonId}/certificate/types/`,
      }).then((data) => {
        context.state.allLoyalityTypes.certificates =
          data.data.result.certificate_types;
        sortedLoyalityByTitle(
          data.data.result.certificate_types.filter((i: any) => i.title[0] !== '#'),
          context.state.sortedLoyalityByName.certificates,
          "certificate"
        );
      });
    },
    getAllLoyalityTypes(context) {
      return Promise.all([
        context.dispatch("getAbonementTypes"),
        context.dispatch("getCertificateTypes"),
      ]);
    },
    buyLoyality(context) {
      context.state.isPaymentLoader = true;
      const clientPhone = context.state.loyalityShopData.clientData.phone;
      const buyerPhone = context.state.loyalityShopData.buyerData.phone;

      let buyLoyalityRequest = null;

      const data: TypeBuyLoyalityData = {
        DesignId: context.state.loyalityShopData.designType,
        SalonId: context.state.salonId,

        SendTo: context.state.loyalityShopData.emailRecipient,

        ClientEmail: context.state.loyalityShopData.clientData.email || null,
        ClientName: context.state.loyalityShopData.clientData.name || null,
        ClientPhone: clientPhone ? clientPhone.replace("+", "").replace(/\s+/g, "") : null,
        
        SuccessURL: 'https://qoob.store/loyalty_shop/',
        FailURL: 'https://qoob.store/loyalty_shop/',
        
      };

      if (context.state.loyalityShopData.emailRecipient === 'other') {
        data.SendTo = context.state.loyalityShopData.clientData.email
      }

      if (context.state.loyalityShopData.receiver === 'other') {
        data.BuyerEmail = context.state.loyalityShopData.buyerData.email || null;
        data.BuyerName = context.state.loyalityShopData.buyerData.name || null;
        data.BuyerPhone = buyerPhone ? buyerPhone.replace("+", "").replace(/\s+/g, "") : null;
      }
      if (context.state.currentLoyalityKind === "certificate") {
        data.Nominal = 0;
        data.CertTypeId = context.state.loyalityShopData.buyLoyalityType;
        buyLoyalityRequest = context.dispatch("buyCertificate", data);
      } else {
        data.AbonementTypeId = context.state.loyalityShopData.buyLoyalityType;
        buyLoyalityRequest = context.dispatch("buyAbonement", data);
      }

      buyLoyalityRequest.then((data) => {
        console.log(data);
        const paymentData = data.data.result.payment;

        context.state.currentPaymentData = paymentData;

        context.state.currentShopStep = 8;

        if (window.parent) {
          window.parent.location.href = paymentData.PaymentURL;
        } else {
          location.href = paymentData.PaymentURL;
        } 
      });
    },
    async rePayment(context) {
      context.state.isPaymentLoader = true

      return await axios({
        method: 'POST',
        url: 'https://qoob.store/loyalty_market/payment/repeat/',
        data: {
          OrderId: context.state.currentPagePayment.OrderId
        }
      }).then((data) => {
        console.log(data);
        const paymentData = data.data.result.payment;

        context.state.currentPaymentData = paymentData;

        if (window.parent) {
          window.parent.location.href = paymentData.PaymentURL;
        } else {
          location.href = paymentData.PaymentURL;
        } 
      });
    },

    async buyCertificate(context, data: TypeBuyLoyalityData) {
      return await axios({
        url: "https://qoob.store/loyalty_market/certificate/",
        method: "POST",
        headers: {
          Authorization: `${context.getters.getAuthToken}`,
        },
        data: data,
      });
    },
    async buyAbonement(context, data) {
      return await axios({
        url: "https://qoob.store/loyalty_market/abonement/",
        method: "POST",
        headers: {
          Authorization: `${context.getters.getAuthToken}`,
        },
        data: data,
      });
    },

    async getCurrentPagePayment(context) {
      return await axios({
        url: `https://qoob.store/api/v1/payments/order/${context.state.orderId}/`,
        method: "GET",
      }).then((data: any) => {
        context.state.currentPagePayment = data.data.result;

        context.state.allLoyalityTypes.certificates.forEach(
          (certificate: TypeCertificateObj) => {
            if (certificate.id === +data.data.result.OrderId.split("-")[0]) {
              context.state.currentPagePayment.type = "certificate";
              context.state.currentPagePayment.currentLoyality = certificate;
            }
          }
        );

        context.state.allLoyalityTypes.abonements.forEach(
          (abonement: TypeAbonementObj) => {
            if (abonement.id === +data.data.result.OrderId.split("-")[0]) {
              context.state.currentPagePayment.type = "abonement";
              context.state.currentPagePayment.currentLoyality = abonement;
            }
          }
        );
      });
    },

    async getPaymentByOrderId(context, orderId) {
      return await axios({
        url: `https://qoob.store/api/v1/payments/order/${orderId}/`,
        method: "GET",
      }).then((data: any) => data.data.result)
    },

    checkPaymentStatus(context) {
      const paymentId = context.state.currentPaymentData.OrderId;

      let checkInterval: any = null

      checkInterval = setInterval(() => {
        context.dispatch('getPaymentByOrderId', paymentId).then(payment => {
          if (payment.success) {
            context.state.isPaymentSuccess = true
            clearInterval(checkInterval)
          }
        })
      }, 5000)
    },

    async postSuccessPagePaymentStatus(context) {
      const paymentId = context.state.currentPagePayment.PaymentId
      return await axios({
        method: 'PUT',
        url: `https://qoob.store/api/v1/payments/${paymentId}/`,
        data: {
          success: true,
        }
      })
    },

    async getDesignsBySalonId(context) {
      return await axios<IResponseDesings>({
        url: 'https://qoob.store/loyalty_market/design/?salon_id=615079',
        method: 'get',
      }).then((res: AxiosResponse<IResponseDesings>) => {
        context.state.allDesignTypes = res.data.result
      }).catch((err) => {
        console.log(err)
      })
    }
  },
  modules: {
    authModule,
  },
});
